export default __webpack_public_path__ + "static/media/logo-small.548134fb.svg";